<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { RouterLink } from "vue-router";
import adminUserService from "../../../services/user/adminUserService";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";

const loadingStore = usePageLoadingStore()
const { $interests, $corpState, $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, $yyyymmdd, $yyyymm, $gb, $bizNum, $userGbKR } = getCurrentInstance().appContext.config.globalProperties;

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
});

const user = computed(() => props.user || {});

const lectureCreateHistories = ref(null); // 강의 개설 내역 TAB

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);

// 강의개설 내역 리스트 조회
const retrieveLectCreateHistoryList = () => {
  loadingStore.loading = true;
  adminUserService.retrieveUserLectureListByCreateId(user.value.userId)
      .then( async (res) => {
        loadingStore.loading = false;
        // console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          lectureCreateHistories.value = res.data.result;
        } else {
        }
      }).catch( (res) =>  {
    // console.log(res);
    loadingStore.loading = false;
  });
}

onMounted(() => {
  retrieveLectCreateHistoryList()
})
</script>
<template>
  <div class="table-form">
    <table class="horizontal" v-if="lectureCreateHistories !== null">
      <tr>
        <th>구분</th>
        <th>강의명</th>
        <th>차시</th>
        <th>신청인원</th>
        <th>선발인원</th>
        <th>신청기간</th>
        <th>교육기간</th>
      </tr>
      <tr v-for="lectCreateHist in lectureCreateHistories">
        <td>{{ lectCreateHist.lectGb === '01' ? '온라인' : '오프라인' }}</td>
        <td class="link text-left"><RouterLink :to="{name:'LectureDetail', params:{id: lectCreateHist.lectId}}">{{ lectCreateHist.lectName }}</RouterLink></td>
        <td>{{ lectCreateHist.lectureIndexCount }}</td>
        <td>{{ lectCreateHist.userLectureCount }}</td>
        <td>{{ lectCreateHist.userLectureSelCount }}</td>
        <td>
          <span v-if="lectCreateHist.regTermGb === '01'">상시</span>
          <span v-else>{{ $yyyymmdd(lectCreateHist.regStartYmd) }} ~ {{ $yyyymmdd(lectCreateHist.regEndYmd) }}</span>
        </td>
        <td>
          <span v-if="lectCreateHist.lectTermGb === '01'">신청일로부터 {{ lectCreateHist.lectTerm }}일</span>
          <span v-else>{{ $yyyymmdd(lectCreateHist.lectStartYmd) }} ~ {{ $yyyymmdd(lectCreateHist.lectEndYmd) }}</span>
        </td>
      </tr>
    </table>
    <div class="result-none" v-if="lectureCreateHistories === null || lectureCreateHistories.length === 0">
      개설한 강의가 없습니다.
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>